// LF360-1839: holding the platform's "duplicate" modifier while dragging a node
// leaves the original in place, so the drop lands a copy instead of moving it.
// Cmd on macOS, Ctrl elsewhere; Alt is kept because it already behaved this way.
//
// Every place that inspects the modifier must agree: `dragstart` picks
// `effectAllowed` and `dragover` picks `dropEffect`, and per the HTML drag-and-
// drop spec a `dropEffect` outside `effectAllowed` cancels the drop outright. If
// one of them read a different modifier, holding it would stop the drop from
// happening at all instead of duplicating.
//
// Kept in its own module so it can be tested without pulling in the editor's
// component graph, and so both native and React drag events can use it.
export const isDuplicateModifier = (
  event: { metaKey: boolean; ctrlKey: boolean; altKey: boolean },
) => event.metaKey || event.ctrlKey || event.altKey;
